module.exports = __webpack_public_path__ + "img/@temp_top_banner.561fe45.png";